import React from 'react';
import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';

const Card = styled.div`
  min-width: 222px;
  width: 100%;
  height: 92px;
  padding: 12px 16px;
  background-color: #fff;
  display: flex;
  align-items: center;
  border-radius: 6px;
  box-sizing: border-box;
  transition: transform 0.2s;
  cursor: pointer;
`;

const CardIcon = styled.span`
  width: 32px;
  height: 32px;
  margin-right: 8px;
  margin-top: 8px;
  font-size: 30px !important;
  align-self: flex-start;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 35%;
`;

const CardInfo = styled.span`
  display: flex;
  flex-direction: column;
  row-gap: 2px;
`;

const CardInfoTitle = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #9a9a9a;
  width: 100%;
`;

const CardInfoPercent = styled.span`
  display: flex;
  gap: 2px;
  align-items: center;
`;

export const skeletonCounter = () => {
  return (
    <>
      <Card>
        <CardIcon>
          <Skeleton width={32} height={32} />
        </CardIcon>
        <CardInfo>
          <Skeleton height={25} width={25} />
          <CardInfoTitle>
            <Skeleton width={130} height={12} />
          </CardInfoTitle>
          <CardInfoPercent className='card-counter-text-percent'>
            <Skeleton width={100} height={12} />
          </CardInfoPercent>
        </CardInfo>
      </Card>
    </>
  );
};
